var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2516_108695)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3334 10.5003C11.3334 10.0401 11.7065 9.66699 12.1667 9.66699H19.6667C19.8877 9.66699 20.0997 9.75479 20.256 9.91107L24.4226 14.0777C24.5789 14.234 24.6667 14.446 24.6667 14.667V23.8337C24.6667 25.2144 23.5474 26.3337 22.1667 26.3337H13.8334C12.4527 26.3337 11.3334 25.2144 11.3334 23.8337V10.5003ZM13 11.3337V23.8337C13 24.2939 13.3731 24.667 13.8334 24.667H22.1667C22.6269 24.667 23 24.2939 23 23.8337V15.0122L19.3215 11.3337H13Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15.5V10.5H19.6667V14.6667H23.8333V16.3333H18.8333C18.3731 16.3333 18 15.9602 18 15.5Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6666 18.8333C14.6666 18.3731 15.0397 18 15.5 18H20.5C20.9602 18 21.3333 18.3731 21.3333 18.8333C21.3333 19.2936 20.9602 19.6667 20.5 19.6667H15.5C15.0397 19.6667 14.6666 19.2936 14.6666 18.8333Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6666 22.1663C14.6666 21.7061 15.0397 21.333 15.5 21.333H20.5C20.9602 21.333 21.3333 21.7061 21.3333 22.1663C21.3333 22.6266 20.9602 22.9997 20.5 22.9997H15.5C15.0397 22.9997 14.6666 22.6266 14.6666 22.1663Z",
    fill: "#2196F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2516_108695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFile);
export default __webpack_public_path__ + "static/media/defaultFile.886c0d11ed1e0f349342d95115fbddaa.svg";
export { ForwardRef as ReactComponent };